export default __webpack_public_path__ + "b48a0fd597c1b459d968a6ffd35497f1.png";